import { READING_HAS_PROTECTED_DATA, requestReadingRecovery } from './readingRecovery';

export const OPEN_READING_REQUIRES_DISPOSITION = 'OPEN_READING_REQUIRES_DISPOSITION';
export const STALE_OPEN_READING = 'STALE_OPEN_READING';
export const STALE_READING_STATUS = 'STALE_READING_STATUS';

const normalRemovalMessage = [
    'Книга зникне з поточної бібліотеки.',
    'Історія читання, оцінки, рецензії та Добірки залишаться збереженими.',
].join('\n\n');

const openReadingMessage = [
    'У вас є незавершене читання цієї книги.',
    'Ви можете зберегти його як «Не дочитано» — книга залишиться у Бібліотеці, або скасувати цю спробу та прибрати книгу.',
].join('\n\n');

function conflictData(error) {
    return error?.response?.data || {};
}

function isConflict(error, code) {
    return error?.response?.status === 409 && conflictData(error).code === code;
}

async function chooseOpenReadingDisposition() {
    const modal = window.decisionModalInstance?.$refs?.modal;
    if (!modal || typeof modal.choose !== 'function') {
        return null;
    }

    try {
        return await modal.choose(
            openReadingMessage,
            [
                {
                    value: 'abandon',
                    label: 'Зберегти як «Не дочитано»',
                    variant: 'primary',
                },
                {
                    value: 'discard',
                    label: 'Скасувати читання і прибрати',
                    variant: 'danger',
                },
            ],
            'Незавершене читання',
            'warning',
            'Не прибирати',
        );
    } catch (_) {
        return null;
    }
}

function knownOpenReading(options) {
    const id = Number(options.openReadingInstanceId || 0);
    const state = options.openReadingState;

    if (!id || !['active', 'paused'].includes(state)) {
        return null;
    }

    return {
        open_reading_instance_id: id,
        open_reading_state: state,
        lock_version: options.lockVersion,
    };
}

function completedResult(response, disposition = null) {
    const status = response?.data?.status ?? null;

    return {
        completed: true,
        removed: status === null,
        status,
        response,
        disposition,
    };
}

async function applyOpenReadingDisposition(deleteRequest, conflict) {
    const disposition = await chooseOpenReadingDisposition();
    if (!disposition) {
        return { completed: false, removed: false, cancelled: true };
    }
    if (!conflict.open_reading_instance_id) {
        return { completed: false, removed: false, stale: true };
    }

    try {
        const response = await deleteRequest({
            open_attempt_disposition: disposition,
            expected_open_reading_instance_id: conflict.open_reading_instance_id,
            ...(conflict.lock_version === null || conflict.lock_version === undefined
                ? {}
                : { lock_version: conflict.lock_version }),
        });

        return completedResult(response, disposition);
    } catch (error) {
        if (isConflict(error, READING_HAS_PROTECTED_DATA) && conflictData(error).recovery) {
            return requestReadingRecovery(conflictData(error).recovery, 'library_removal');
        }
        if (isConflict(error, STALE_OPEN_READING)
            || isConflict(error, STALE_READING_STATUS)
            || isConflict(error, OPEN_READING_REQUIRES_DISPOSITION)) {
            return { completed: false, removed: false, stale: true, error };
        }

        throw error;
    }
}

export async function requestLibraryRemoval(deleteRequest, options = {}) {
    const openReading = knownOpenReading(options);
    if (openReading) {
        return applyOpenReadingDisposition(deleteRequest, openReading);
    }

    const confirmed = await window.confirm(
        normalRemovalMessage,
        'Прибрати книгу з бібліотеки?',
        'warning',
    );
    if (!confirmed) {
        return { completed: false, removed: false, cancelled: true };
    }

    try {
        const response = await deleteRequest({
            ...(options.lockVersion === null || options.lockVersion === undefined
                ? {}
                : { lock_version: options.lockVersion }),
        });

        return completedResult(response);
    } catch (error) {
        if (!isConflict(error, OPEN_READING_REQUIRES_DISPOSITION)) {
            throw error;
        }

        return applyOpenReadingDisposition(deleteRequest, conflictData(error));
    }
}
